document.addEventListener('DOMContentLoaded', async () => {
  // Get directions
  const getDirectionsBtns = document.querySelectorAll('.js-rlx-directions-btn');
  getDirectionsBtns?.forEach((btn) => {
    btn.addEventListener('click', () => {
      try {
        window._satellite.track('getDirections');
      } catch {
        console.error('Adobe Analytics not loaded');
      }
    });
  });

  // "Find a Store" button
  const findStoreBtns = document.querySelectorAll('.js-rlx-find-store-btn');
  findStoreBtns?.forEach((btn) => {
    btn.addEventListener('click', () => {
      try {
        window._satellite.track('findStore');
      } catch {
        console.error('Adobe Analytics not loaded');
      }
    });
  });

  // Call button
  const callBtns = document.querySelectorAll('.js-rlx-call-btn');
  callBtns?.forEach((btn) => {
    btn.addEventListener('click', () => {
      try {
        window._satellite.track('contactCall');
      } catch {
        console.error('Adobe Analytics not loaded');
      }
    });
  });
});
